import { Link } from "react-router-dom";
import { ArrowUpRight, Building2, Layers, Frame, Anchor, BrickWall, Warehouse, SquareStack, Square, Hammer, Wrench } from "lucide-react";
import { SERVICES } from "@/data/content";

const ICONS = { Building2, Layers, Frame, Anchor, BrickWall, Warehouse, SquareStack, Square, Hammer, Wrench };

export default function Services() {
  return (
    <section className="bg-white" data-testid="services-section" id="leistungen">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Leistungen</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0C2749]" style={{ fontFamily: "Outfit" }}>
              Alles aus einer Hand. <span className="text-[#2873B8]">Vom Aushub bis zum Dachgeschoss.</span>
            </h2>
          </div>
          <Link
            to="/leistungen"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#0C2749] hover:text-[#2873B8] transition-colors group"
            data-testid="services-all-link"
          >
            Alle Leistungen
            <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.icon] || Building2;
            const featured = idx === 0;
            return (
              <Link
                key={s.slug}
                to={`/leistungen/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className={`group relative bg-white hover:bg-[#F5F5F5] transition-colors p-8 md:p-10 ${featured ? "lg:col-span-2 lg:row-span-2" : ""}`}
              >
                {featured && (
                  <div className="relative h-56 lg:h-72 mb-6 overflow-hidden rounded-sm">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0C2749]/40 to-transparent" />
                  </div>
                )}
                <div className="flex items-start justify-between mb-4">
                  <div className="inline-flex items-center justify-center h-11 w-11 rounded-sm bg-grad-primary text-white">
                    <Icon className="w-5 h-5" />
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-[#2873B8] group-hover:rotate-45 transition-all" />
                </div>
                <h3 className={`font-semibold text-[#0C2749] mb-2 ${featured ? "text-2xl lg:text-3xl" : "text-xl"}`} style={{ fontFamily: "Outfit" }}>
                  {s.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-4">{s.short}</p>
                {featured && (
                  <ul className="space-y-1 text-sm text-[#0C2749]">
                    {s.bullets.map((b) => (
                      <li key={b} className="flex items-center gap-2">
                        <span className="h-1 w-4 bg-[#2873B8]" /> {b}
                      </li>
                    ))}
                  </ul>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
